module.exports = __webpack_public_path__ + "static/media/bgm.ff73dfbe.png";